var React = require('react');

let BaseComponent = require('../../shared/base');

let client = require('../../../../sdk/client');

var Moment = require('moment');

require('daterangepicker');
const sortTypes = {
    up: {
        class: 'sort-up'
    },
    down: {
        class: 'sort-down'
    },
    default: {
        class: 'sort'
    }
    
};

class BackordersTable extends BaseComponent{

    constructor(props){
        super(props)
        this.state = {
            displayData:[{
                OrderDate:"",
                PartDescription:"Cargando...",
                UnitPrice: 0,
                SubTotalAmount: 0
            }],
            tableData:[],
            perPage: 20,
            pages: [],
            currentPage: 0,
            totalQtty: 0,
            totalPrice: 0,
            endDateFilter: null,
            startDateFilter: null,
            orderedBy: "",
            requestUserData: {
                //Placeholder data
                "operatingUnitID": 446, // este siempre es de megamak
                "customerId": 0
            },
            branchs: [],
            currentSort: 'default'
        }
        Moment.locale('es');

        this.onTimestampChanged = this.onTimestampChanged.bind(this);

    }

    onTimestampChanged(startDate, endDate) {
        startDate = startDate !== null ? startDate.split('T')[0].replace(/-/g, '/') : startDate;
        endDate = endDate !== null ? endDate.split('T')[0].replace(/-/g, '/') : endDate;

        this.setState({
            startDateFilter: startDate,
            endDateFilter: endDate
        });
    }

    componentDidMount(){
        const self = this;
        $('#filter-datepicker').daterangepicker({
            autoUpdateInput: false,
            opens: 'left',
            locale: {
                cancelLabel: 'Clear'
            },
            autoApply: true
        });
  
        //$('#filter-datepicker').val('Timestamp');
        $('#filter-datepicker').on('apply.daterangepicker', function(ev, picker) {
            self.onTimestampChanged(picker.startDate.utc(true).format(), picker.endDate.utc(true).format());
            //$(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
            $(this).addClass('filled');
        });
  
        $('#filter-datepicker').on('cancel.daterangepicker', function(ev, picker) {
            self.onTimestampChanged(null, null);
            //$(this).val('');
            $(this).removeClass('filled');
        });
        //Filter Range Calendar 

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const orderId = urlParams.get("orderID");

        let requestBody = this.state.requestUserData;

        client.Users.getUserDetails({
            excludeToken: false,
            userId: this.props.user.ID,
            includeUserCustomFields: true
        }, function (err, user) {
            requestBody.customerId = user.CustomFields != null ? user.CustomFields.find(x => x.Name == process.env.NAME_CF_CLIENTE_ID).Values[0] : undefined;

            if (orderId != null) {
                requestBody.orderID = orderId
            }

            client.Backorders.getBackorders(requestBody)
            .then((response) => {
                let tempPages = [];
                var tempQtty = 0;
                var tempPrice = 0;


                let today = new Date();

                for (let index = 0; index < response.length; index++) {
                    const element = response[index];

                    tempQtty = tempQtty + element.BOQuantity;
                    tempPrice = tempPrice + element.SubTotalAmount;

                    let orderDay = new Date(element.OrderDate.split('T')[0]);
                    let daysPassed = (today - orderDay)/ (1000 * 60 * 60 * 24);

                    element.daysSince = Math.floor(daysPassed);

                    if(index/(self.state.perPage) > tempPages.length){
                        tempPages.push(Math.floor(index/self.state.perPage));
                    }
                }
                self.setState({
                    tableData:response,
                    displayData:response.slice(0,self.state.perPage),
                    pages:tempPages,
                    totalQtty: tempQtty,
                    totalPrice: tempPrice
                });

                self.orderBy("fecha");
            },
            (error) => {
                console.log(error);
            });
        });

        let parameters = {
            pluginId: process.env.ADMINISTRACION_ALMACENES, 
            tableName:"ConfiguracionUsuario", 
            query:  [{
                "Name": "UserId",
                "Operator": "equal",
                "Value": this.props.user.ID
            }]
        };

        let branchs = [{nombre:"Todos",id:"0"}];

        const promiseBranches = new Promise((resolve, reject) => {

            client.CustomTables.searchCustomTable(parameters, function (err, result) {
                resolve(result);
            });
        });

        Promise.all([promiseBranches]).then(response => {
            response[0].Records.forEach(element => {
                parameters = {
                    pluginId: process.env.ADMINISTRACION_ALMACENES, 
                    tableName:"Almacenes", 
                    query:  [{
                        "Name": "Nombre",
                        "Operator": "equal",
                        "Value": element.AlmacenFacturacion
                    }]
                };
    
                const promiseBranchId = new Promise((resolve, reject) => {
    
                    client.CustomTables.searchCustomTable(parameters, function (err, result) {
                        resolve(result);
                    });
                });
        
                Promise.all([promiseBranchId]).then(response => {
                    branchs.push({nombre: element.AddressName, id: response[0].Records[0].BrachId});
                    this.setState({branchs: branchs})
                });
            });


            this.setState({branchs: branchs})
        });

    }

    filterData(e) {
        let partFilter = document.getElementById("num_parte").value;
        let branchFilter = document.getElementById("filter-branch").value;

        let requestBody = this.state.requestUserData;

        if(partFilter !=="" && partFilter!== null){
            requestBody.partCode = partFilter;
        } else {
            delete requestBody.partCode;
        }

        if(this.state.startDateFilter !=="" && this.state.startDateFilter!== null){
            requestBody.startOrderDate = this.state.startDateFilter.replace(/\//g, '-');
            requestBody.endOrderDate = this.state.endDateFilter.replace(/\//g, '-');
        } else {
            delete requestBody.startOrderDate;
            delete requestBody.endOrderDate;
        }

        if(branchFilter !== "0" && branchFilter!== null){
            requestBody.branchID = branchFilter;
        } else {
            delete requestBody.branchID;
        }
        
        client.Backorders.getBackorders(requestBody)
        .then((response) => {

            let tempPages = [];
            let today = new Date();
            var tempQtty = 0;
            var tempPrice = 0;

            for (let index = 0; index < response.length; index++) {
                const element = response[index];

                tempQtty = tempQtty + element.BOQuantity;
                tempPrice = tempPrice + element.SubTotalAmount;

                let orderDay = new Date(element.OrderDate.split('T')[0]);
                let daysPassed = (today - orderDay)/ (1000 * 60 * 60 * 24);

                element.daysSince = Math.floor(daysPassed);

                if(index/(this.state.perPage) > tempPages.length){
                    tempPages.push(Math.floor(index/this.state.perPage));
                }
            }

            this.setState({
                tableData: response,
                displayData: response.slice(0,this.state.perPage),
                currentPage: 0,
                pages:tempPages,
                totalQtty: tempQtty,
                totalPrice: tempPrice
            });
        });
    }

    clearFilters() {    
        let requestBody = this.state.requestUserData;

        delete requestBody.partCode;
        delete requestBody.startOrderDate;
        delete requestBody.endOrderDate;
        delete requestBody.branchID;

        let branchSelect = document.getElementById("filter-branch");
        
        client.Backorders.getBackorders(requestBody)
        .then((response) => {
            
            let tempPages = [];
            let today = new Date();
            
            for (let index = 0; index < response.length; index++) {
                const element = response[index];
                
                let orderDay = new Date(element.OrderDate.split('T')[0]);
                let daysPassed = (today - orderDay)/ (1000 * 60 * 60 * 24);
                
                element.daysSince = Math.floor(daysPassed);

                if(index/(this.state.perPage) > tempPages.length){
                    tempPages.push(Math.floor(index/this.state.perPage));
                }
            }

            this.setState({
                tableData: response,
                displayData: response.slice(0,this.state.perPage),
                currentPage: 0,
                pages:tempPages
            });

            branchSelect.value = "0";
            document.getElementById("num_parte").value = ""
            document.getElementById("filter-datepicker").value = "Rango de fechas"
        });
    }

    handlePageChange(page){
        this.setState({
            displayData: this.state.tableData.slice(page*this.state.perPage, (page+1)*this.state.perPage),
            currentPage: page
        })
    }

    handleDownloadClick(){
        //                                                          //get today date in string format
        var date = new Date();
        var strDate = String(date.getDate()).padStart(2,'0') + "-" + 
            String(date.getMonth() + 1).padStart(2,'0') + "-" + 
            String(date.getFullYear());

        //                                                          //Csv file header
        var strFile = 
            "Fecha de Pedido,Dias desde pedido,Pedido,Tipo de pedido,Referencia,Numero de parte,Descripcion,Cantidad,Precio,Total\n";
        
        client.Backorders.getBackorders(this.state.requestUserData)
        .then((response) => {
            let today = new Date();

            for (let index = 0; index < response.length; index++) {
                let orderDay = new Date(response[index].OrderDate.split('T')[0]);
                let daysSince = (today - orderDay)/ (1000 * 60 * 60 * 24);

                let descripcion = response[index].PartDescription.includes(",") ? 
                    ('"' + response[index].PartDescription + '"') : 
                    (response[index].PartDescription)

                strFile = strFile +
                response[index].OrderDate.split('T')[0] + "," +
                Math.floor(daysSince) + "," +
                response[index].OrderID + "," +
                response[index].OrderType + "," +
                response[index].OrderReference + "," +
                response[index].PartCode + "," +
                descripcion + "," +
                response[index].BOQuantity + ",$" +
                response[index].UnitPrice + ",$" +
                response[index].SubTotalAmount + "\n"
            }
            strFile = strFile + ",,,,,,Total," + this.state.totalQtty + ",,$" + this.state.totalPrice;

        
            downloadString(strFile,"text/csv","Lista Backorders " + strDate + ".csv");
        },
        (error) => {
            console.log(error);
        });
    }

    orderBy(column){

        let arrOrderedData = this.state.tableData;
        let nextSort;
        if(this.state.orderedBy !== column){
            nextSort = 'up';
            /* CASE START*/
            if(column === "fecha"){
                arrOrderedData.sort((a, b) => (a.OrderDate > b.OrderDate) ? 1 : -1);
            } else if(column === "dias"){
                arrOrderedData.sort((a, b) => (a.daysSince > b.daysSince) ? 1 : -1);
            } else if(column === "pedido"){
                arrOrderedData.sort((a, b) => (a.OrderID > b.OrderID) ? 1 : -1);
            } else if(column === "tipo"){
                arrOrderedData.sort((a, b) => (a.OrderType > b.OrderType) ? 1 : -1);
            } else if(column === "referencia"){
                arrOrderedData.sort((a, b) => (a.OrderReference > b.OrderReference) ? 1 : -1);
            } else if(column === "parte"){
                arrOrderedData.sort((a, b) => (a.PartCode > b.PartCode) ? 1 : -1);
            } else if(column === "descripcion"){
                arrOrderedData.sort((a, b) => (a.PartDescription > b.PartDescription) ? 1 : -1);
            } else if(column === "cantidad"){
                arrOrderedData.sort((a, b) => (a.BOQuantity > b.BOQuantity) ? 1 : -1);
            } else if(column === "precio"){
                arrOrderedData.sort((a, b) => (a.UnitPrice > b.UnitPrice) ? 1 : -1);
            } else if(column === "total"){
                arrOrderedData.sort((a, b) => (a.SubTotalAmount > b.SubTotalAmount) ? 1 : -1);
            }
            /* CASE END */

            this.setState({
                tableData:arrOrderedData,
                displayData: arrOrderedData.slice(this.state.currentPage*this.state.perPage, (this.state.currentPage+1)*this.state.perPage),
                orderedBy: column,
                currentSort: nextSort
            });
        } else {
            nextSort = 'down';
            /* CASE START*/
            if(column === "fecha"){
                arrOrderedData.sort((a, b) => (a.OrderDate < b.OrderDate) ? 1 : -1);
            } else if(column === "dias"){
                arrOrderedData.sort((a, b) => (a.daysSince < b.daysSince) ? 1 : -1);
            } else if(column === "pedido"){
                arrOrderedData.sort((a, b) => (a.OrderID < b.OrderID) ? 1 : -1);
            } else if(column === "tipo"){
                arrOrderedData.sort((a, b) => (a.OrderType < b.OrderType) ? 1 : -1);
            } else if(column === "referencia"){
                arrOrderedData.sort((a, b) => (a.OrderReference < b.OrderReference) ? 1 : -1);
            } else if(column === "parte"){
                arrOrderedData.sort((a, b) => (a.PartCode < b.PartCode) ? 1 : -1);
            } else if(column === "descripcion"){
                arrOrderedData.sort((a, b) => (a.PartDescription < b.PartDescription) ? 1 : -1);
            } else if(column === "cantidad"){
                arrOrderedData.sort((a, b) => (a.BOQuantity < b.BOQuantity) ? 1 : -1);
            } else if(column === "precio"){
                arrOrderedData.sort((a, b) => (a.UnitPrice < b.UnitPrice) ? 1 : -1);
            } else if(column === "total"){
                arrOrderedData.sort((a, b) => (a.SubTotalAmount < b.SubTotalAmount) ? 1 : -1);
            }
            /* CASE END */

            column = column + "rev";

            this.setState({
                tableData:arrOrderedData,
                displayData: arrOrderedData.slice(this.state.currentPage*this.state.perPage, (this.state.currentPage+1)*this.state.perPage),
                orderedBy: column,
                currentSort: nextSort
            });
        }
    }

    renderOrderedArrow(column) {
        if(column === this.state.orderedBy){
            return <p>▼</p>
        } else if (column + "rev" === this.state.orderedBy) {
            return <p>▲</p>
        } else {
            return <p style= {{color : "lightgrey"}}>▼</p>
        }
    }

    renderHeadersort() {
        if (typeof this.renderCustomHeader == 'function') return this.renderCustomHeader();
        return (
            <thead>
                <tr>
                    <th>Fecha de pedido<button className="btnsort" onClick={() => this.orderBy("fecha")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Días desde pedido<button className="btnsort" onClick={() => this.orderBy("dias")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Pedido<button className="btnsort" onClick={() => this.orderBy("pedido")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Tipo de pedido<button className="btnsort" onClick={() => this.orderBy("tipo")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Referencia<button className="btnsort" onClick={() => this.orderBy("referencia")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>No. de parte<button className="btnsort" onClick={() => this.orderBy("parte")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Descripción<button className="btnsort" onClick={() => this.orderBy("descripcion")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Cantidad<button className="btnsort" onClick={() => this.orderBy("cantidad")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Precio<button className="btnsort" onClick={() => this.orderBy("precio")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Total<button className="btnsort" onClick={() => this.orderBy("total")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    
                </tr>
            </thead>
           
        );
    }

    render() {
        let current = this.state.currentPage;
        let maxPage = this.state.pages.length - 1;
        let strDateRange = this.state.startDateFilter ? 
            this.state.startDateFilter + " - " + this.state.endDateFilter : 
            "Rango de fechas";

        return(
            this.props.user !== undefined ? <div>
                <h3 className="BO_title">Pedidos en backorder</h3>
                <div className="BO_filters">
                    <div className="BO_filtersField">     
                        <label className="BO_inputLabel" htmlFor="num_parte">Número de parte</label>
                        <input className="BO_inputField"
                            type="text"
                            id="num_parte"/>
                    </div>
                    <div className="BO_filtersField">
                        <label className="BO_inputLabel" htmlFor="rango_fecha_inicio">Intervalo de fechas</label>
                        <input 
                            type="text"
                            className="BO_inputField"
                            name="fecha"
                            id="filter-datepicker"
                            defaultValue={strDateRange}   />
                           
                    </div>
                    <div className="BO_filtersField">
                        <label className="BO_inputLabel" htmlFor="almacen">Sucursal</label>
                        <select name="depot" id="filter-branch">
                            {this.state.branchs.map(function (item, key){
                                    return <option value={item.id} key={key}>{item.nombre}</option>
                                })}
                        </select>
                    </div>
                    <div id="BO_container-submit">
                        <input type="submit" className="btn btn-sassy btn-actions-backorder" id="btnApply" defaultValue="Filtrar" onClick={() => this.filterData(this)}></input>
                        <input type="submit" style={{marginLeft:"15px"}} className="btn btn-sassy btn-actions-backorder" defaultValue="Restablecer" onClick={() => this.clearFilters()}></input>
                    </div>
                    
                </div>
                <div className="BO_download">
                    <img src='/assets/images/bepensa/download_icon.png' alt="" onClick = {() => this.handleDownloadClick()}/>
                </div>
                <div className="BO_table">
                    <table style={{width:"100%"}}>
                        {this.renderHeadersort()}
                        <tbody>
                            {
                            this.state.displayData.length > 0 ?
                                this.state.displayData.map(function (item, key){
                                    return (<tr key={key}>
                                        <td className="BO_data">{item.OrderDate.split('T')[0]}</td>
                                        <td className="BO_data">{item.daysSince}</td>
                                        <td className="BO_data">{item.OrderID}</td>
                                        <td className="BO_data">{item.OrderType}</td>
                                        <td className="BO_data">{item.OrderReference}</td>
                                        <td className="BO_data">{item.PartCode}</td>
                                        <td className="BO_data">{item.PartDescription}</td>
                                        <td className="BO_data">{item.BOQuantity}</td>
                                        <td className="BO_data">{"$"+item.UnitPrice.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }</td>
                                        <td className="BO_data">{"$"+item.SubTotalAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }</td>
                                    </tr>)
                                })
                            :
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>No se encontraron resultados con esos parámetros</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>}
                            {current === maxPage ? <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="totalTag">Total</td>
                                <td>{this.state.totalQtty}</td>
                                <td></td>
                                <td>{"$" + this.state.totalPrice.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }</td>
                            </tr>
                            :
                            null}
                        </tbody>
                    </table>
                    <br />
                </div>
                <p style={{margin: "0 2%"}}>Todos los precios en esta sección están expresados en Pesos Mexicanos(MXN). Los montos mostrados en las columnas Precio y Total son de referencia. Una vez que Megamak reciba la orden en Backorder, ésta se facturará al precio y tipo de cambio del día</p>
                <div className="BO_PageButtons">
                    {
                        maxPage > 0 ? <div
                        className="BO_PageButton"
                        onClick={() => this.handlePageChange(current === 0 ? maxPage : current - 1)}>
                            {"<"}
                        </div>
                        :
                        null
                    }
                    {
                        this.state.pages.map(function(item){
                            return (
                                <div
                                className={current === item ? "BO_Selected BO_PageButton" : "BO_PageButton"}
                                key={item}
                                onClick={() => this.handlePageChange(item)}>
                                    {item + 1}
                                </div>
                            )
                        },this)
                    }
                    {
                        maxPage > 0 ? <div
                        className="BO_PageButton"
                        onClick={() => this.handlePageChange(current === maxPage ? 0 : current + 1)}>
                            {">"}
                        </div>
                        : null
                    }
                </div>
            </div>
            :
            <div>
                Por favor inicia sesion.
            </div>
        );
    }
}

function downloadString(text, fileType, fileName) {
    var blob = new Blob([text], { type: fileType });
    
    var a = document.createElement('a');
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function() { URL.revokeObjectURL(a.href); }, 1500);
}

module.exports = BackordersTable;